import { useMemo } from "react"

import { Modal, Text } from "ui-kit/components-branded/index"
import { Icon } from "components"
import { isPsyAccountPage } from "app/AppRouter/utils"
import { Call } from "modules/Call/queries"

interface ContactModal {
    active: boolean
    setActive: (value: boolean) => void
    fallBackData?: Call
}

export function ContactModal({ active, setActive, fallBackData }: ContactModal) {
    const handleClickClose = () => {
        setActive(false)
    }

    const content = useMemo(() => {
        if (isPsyAccountPage()) {
            return {
                description: (
                    <>
                        Перейдите в&nbsp;другой сервис видеосвязи, если ошибка не&nbsp;проходит
                        после обновления страницы. Сообщите клиенту, что вы&nbsp;перешли
                        в&nbsp;другой сервис.
                    </>
                ),
                phoneTitle: <>Телефон клиента:</>,
                phone: fallBackData?.booking.client.phone,
            }
        } else {
            return {
                description: (
                    <>
                        Перейдите в&nbsp;другой сервис видеосвязи, если ошибка не&nbsp;проходит
                        после обновления страницы.
                    </>
                ),
                phoneTitle: <>Телефон для связи с&nbsp;психологом:</>,
                phone: fallBackData?.booking.psychologist.private_number,
            }
        }
    }, [])

    return (
        <div className="call-page-error-contact-modal">
            <Modal
                isActive={active}
                className="call-page-error-contact-modal__modal"
                onBackgroundClick={handleClickClose}
                data-testid="call-errorpage-help-modal"
            >
                <div className="call-page-error-contact-modal__container">
                    <div className="call-page-error-contact-modal__title has-text-weight-medium mgb-3">
                        Как подключиться к&nbsp;сессии
                    </div>
                    <div className="call-page-error-contact-modal__update p-3 mgb-3">
                        {content.description}
                    </div>
                    {fallBackData?.booking.psychologist.video_call_handle}
                    {content.phone && (
                        <>
                            <hr className="call-page-error-contact-modal__line" />
                            <Text className="is-block has-text-weight-medium">
                                Остались вопросы?
                            </Text>
                            <Text className="is-block">
                                {content.phoneTitle}&nbsp;
                                <span className="is-nowrap">{content.phone}</span>
                            </Text>
                        </>
                    )}
                    <div
                        className="call-page-error-contact-modal__close"
                        onClick={handleClickClose}
                    >
                        <Icon type="close" />
                    </div>
                </div>
            </Modal>
        </div>
    )
}
